import { ErrorResponse } from '../../../../common/types/errorRespose';
import React from 'react';
import { Box, Button, Flexbox, Icon, Modal, Select, Typography } from '@hiiretail/synergy-ui';
import { ErrorBox } from '../../../../common/components/ErrorBox/ErrorBox';
import { useAddUserToGroupForm } from '../../hooks/useAddUserToGroupForm';
import { GroupDto, UserDto } from '../../../../api-client';
import { Controller } from 'react-hook-form';

type AddUserToGroupModalProps = {
  onClose: () => void;
  isOpen: boolean;
  isAdding: boolean;
  error: ErrorResponse | null;
  user: UserDto;
  groups: GroupDto[];
  addUserToGroup: ({ userId, groupId }: { userId: string; groupId: string }) => void;
};

type AddUserToGroupModalComponent = React.FC<AddUserToGroupModalProps>;

type AddUserToGroupModalFormData = {
  group: {
    value: string;
    label: string;
  };
};

export const AddUserToGroupModal: AddUserToGroupModalComponent = ({
  onClose,
  isOpen,
  isAdding,
  error,
  user,
  groups,
  addUserToGroup,
}) => {
  const { control, handleSubmit, formState, reset } = useAddUserToGroupForm();

  const onFormSubmit = (formData: AddUserToGroupModalFormData) => {
    addUserToGroup({ userId: user.id, groupId: formData.group.value });
    reset({
      group: null,
    });
  };

  const getOptions = () => {
    return groups.map((group) => ({
      value: group.id,
      label: group.name,
    }));
  };

  return (
    <Modal
      data-testid="add-user-to-group-modal"
      title={`Add ${user.name} to group`}
      onClose={onClose}
      open={isOpen}
      footer={
        <Flexbox container justifyContent="flex-end">
          <Button
            type="submit"
            onClick={handleSubmit(onFormSubmit)}
            disabled={(formState?.errors && !!Object.entries(formState?.errors).length) || isAdding}
          >
            {isAdding ? 'Adding ...' : 'Add'}
          </Button>
        </Flexbox>
      }
    >
      <ErrorBox error={error} />
      <form>
        <Box mb={80}>
          <Controller
            name="group"
            control={control}
            render={({ field: { value, onChange } }) => (
              <>
                <Select
                  disabled={isAdding}
                  isClearable={false}
                  fullWidth
                  name="group"
                  label="Groups"
                  data-testid="group-selector"
                  value={value}
                  // @ts-ignore
                  hint={
                    <Flexbox container gutter={2}>
                      <Flexbox item>
                        <Icon.Info color={() => '#757575'} />
                      </Flexbox>
                      <Flexbox item>
                        <Typography variant="body2" color={() => '#757575'}>
                          Select a group from the list
                        </Typography>
                      </Flexbox>
                    </Flexbox>
                  }
                  // @ts-ignore
                  options={getOptions() || []}
                  error={formState.errors?.group?.message}
                  onChange={onChange}
                />
              </>
            )}
          />
        </Box>
      </form>
    </Modal>
  );
};
